<template>
  <section @click.stop="click($event)" v-show="modalOpen" :class="style.modal">
    <div :class="style.cross" v-if="headerModal">
      <GhostButton :icon="closeIcon" @click.stop="off" />
    </div>
    <div :class="style.mainBlock">
      <slot />
    </div>
  </section>
</template>
<script lang="ts">
import {defineComponent} from "vue";
import style from "./ModalBlock.module.scss";
import GhostButton from "@/elements/UI/button/ButtonStyle/Default/ghost/GhostButton.vue";
import closeIcon from "$images/icons/button/Name=Close, Size=16, Tone=Default.svg";

export default defineComponent({
  components: {GhostButton},
  props: {
    model: {
      type: Boolean,
      default: false
    },
    headerModal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      style,
      modalOpen: false,
      closeIcon
    };
  },
  created() {
    this.modalOpen = this.model;
    document.addEventListener("keyup", this.handleEscClose);
  },

  beforeUnmount() {
    document.removeEventListener("keyup", this.handleEscClose);
  },
  methods: {
    click(e: MouseEvent) {
      const target = e.target as HTMLElement;
      const classList = Array.from(target.classList);
      if (classList.includes(this.style.modal)) {
        this.off();
      }
    },
    handleEscClose(e: KeyboardEvent) {
      if (this.modalOpen && (e.key == "Escape" || e.keyCode == 27)) {
        this.off();
      }
    },
    off() {
      this.modalOpen = false;
    }
  },
  watch: {
    model(data) {
      this.modalOpen = data;
      if (data) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    },
    modalOpen(data) {
      this.$emit("update:modelValue", data);
    }
  }
});
</script>
